// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { replaceInChain } from "@insite/client-framework/HandlerCreator";
import {
    chain,
    SetPaymentDetailsState,
} from "@insite/client-framework/Store/Pages/OnePageCheckout/Handlers/SetInitialValues";

export const XngSetPaymentDetailsState: typeof SetPaymentDetailsState = ({ dispatch, getState }) => {
    const { isShippingAddressUpdateRequired, isBillingAddressUpdateRequired, paymentDetailsState } =
        getState().pages.onePageCheckout;
    if (paymentDetailsState === "complete") {
        return;
    }

    // XNG-Changes: remove isBillingAddressUpdateRequired since we don't have Bill-to update in Checkout
    const newPaymentDetailsState = isShippingAddressUpdateRequired ? "waiting" : "active";

    dispatch({
        type: "Pages/OnePageCheckout/SetPaymentDetailsState",
        paymentDetailsState: newPaymentDetailsState,
    });
};

replaceInChain(chain, SetPaymentDetailsState, XngSetPaymentDetailsState);
